import { Box, IconButton, Stack, Tooltip } from '@mui/material';
import { kebabCase } from 'change-case';
import { FC } from 'react';

export interface ActionsConfiguration {
    icon: React.ReactNode;
    title?: string;
    onClick: () => void;
    testId?: string;
    disabled?: boolean;
}

interface ActionsCellRendererProps {
    actions: ActionsConfiguration[];
}

export const ActionsCellRenderer: FC<ActionsCellRendererProps> = ({ actions }) => (
    <Stack
        direction="row"
        sx={{
            alignItems: 'center',
            justifyContent: 'center',
        }}
    >
        {actions.map((action, index) => {
            const actionKey = `${action.title}-${index}`;
            const button = (
                <IconButton
                    key={actionKey}
                    onClick={action.onClick}
                    title={action.disabled ? undefined : action.title}
                    data-testid={action.testId}
                    disabled={action.disabled}
                    className={kebabCase(action.title || 'action-button')}
                >
                    {action.icon}
                </IconButton>
            );

            return action.disabled ? (
                <Tooltip key={actionKey} title={action.title}>
                    <Box component="span" sx={{ display: 'inline-flex' }}>
                        {button}
                    </Box>
                </Tooltip>
            ) : (
                <Box key={actionKey} component="span" sx={{ display: 'inline-flex' }}>
                    {button}
                </Box>
            );
        })}
    </Stack>
);
